import React, { useEffect,useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";

import makePath from '../../utils/makePath';
import { Checkbox as MuiCheckbox, FormControlLabel, makeStyles } from '@material-ui/core';
import { setItem } from "../../actions";
import { useDirty, useFormElementCleanUp } from '../../hooks';

const useStyles = makeStyles((theme) => ({
  alignRight: {
    marginLeft: 'auto',
  }
}))

export const Checkbox = React.memo(({alignRight,callback,given,label,name, ...props}) => {
  const [checked, setChecked] = useState(false);  
  const classes = useStyles();
  const dispatch = useDispatch();
  const setDirty = useDirty();

  const path = makePath(props.path, name);
  useFormElementCleanUp(path);
  
  const updateChecked = useCallback(() => {
    setChecked(!checked);
    setDirty(true);
    dispatch(setItem(path, !checked));
    if (callback) {
      callback(name, !checked)
    }
  }, [callback, checked, dispatch, name, path, setDirty])

  useEffect(() => {
    if (given) {
      setChecked(given);
      callback(name, given)
    }
  }, [callback,given,name]);

  return (
    <FormControlLabel
      className={alignRight ? classes.alignRight : ''}
      control={
        <MuiCheckbox
          {...props}
          size="small"
          checked={checked}
          onChange={updateChecked}
          name={name}
          color="primary"
        />
      }
      label={label}
    />
  )
})

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  callback: PropTypes.func
}